<script>
  import { fade } from "svelte/transition";

  const priceId = "pri_01kf3m4vc56c5nxv4fag3h4b23";

  function handleSubscribe() {
    if (typeof window !== "undefined" && window.Paddle) {
      window.Paddle.Checkout.open({
        items: [
          {
            priceId: priceId,
            quantity: 1,
          },
        ],
        settings: {
          successUrl: "https://everymov.com/app_41234",
        },
      });
    }
  }
</script>

<div class="fixed bottom-0 left-0 right-0 flex justify-center z-50">
  <div
    class="bg-neutral-900/80 px-6 py-6 rounded-t-xl shadow-lg border border-neutral-800 text-center max-w-md w-full backdrop-blur-xl"
    transition:fade
  >
    <button
      id="subscribe-btn"
      on:click={handleSubscribe}
      class="animate-bounce w-full bg-indigo-600 hover:bg-indigo-700 text-white py-4 px-8 rounded-lg text-lg font-semibold transition-colors duration-200 shadow-md hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-indigo-400 flex items-center justify-center gap-2"
    >
      Get Lifetime Access
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="h-5 w-5"
        viewBox="0 0 20 20"
        fill="currentColor"
      >
        <path
          fill-rule="evenodd"
          d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
          clip-rule="evenodd"
        />
      </svg>
    </button>
    <p class="mt-2 text-gray-300/50 text-sm">Pay once · Use forever · $9.99</p>
  </div>
</div>

<style>
  @keyframes bounce {
    0%,
    100% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(-5px);
    }
  }

  .bounce-button {
    animation: bounce 2s ease-in-out infinite;
  }
</style>
